module.exports = __webpack_public_path__ + "static/img/vote-06.24200b6.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/vote/vote-06.png
// module id = yNvf
// module chunks = 1